import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Styles from './index.module.scss';

const PageHeader = ({ className, headerInfo }) => {
  const { title = {}, subtitle = {}, tags = [], headerBgImage } = headerInfo;
  const bgStyle = headerBgImage ? { backgroundImage: `url(${headerBgImage})`} : {};

  return (
    <div className={cx(Styles.root, className)} style={bgStyle}>
      {
        title.label && (
          <div className={Styles.title} style={{ color: title.color }}>{title.label}</div>
        )
      }
      {
        subtitle.label && (
          <div className={Styles.subtitle} style={{ color: subtitle.color }}>{subtitle.label}</div>
        )
      }
      {
        tags.length > 0 && (
          <div className={Styles.tags}>
            {
              tags.slice(0, 4).map(({ label, color, bgColor }) => (
                <div key={label} className={Styles.tag} style={{ color, backgroundColor: bgColor }}>{label}</div>
              ))
            }
          </div>
        )
      }
    </div>
  );
};

PageHeader.propTypes = {
  className: PropTypes.string,
  headerInfo: PropTypes.shape({}),
};

PageHeader.defaultProps = {
  className: '',
  headerInfo: {},
};

export default PageHeader;
